import { render } from "./ClientEdit.html?vue&type=template&id=c62350ac&scoped=true&ts=true"
import script from "./ClientEdit.ts?vue&type=script&lang=ts"
export * from "./ClientEdit.ts?vue&type=script&lang=ts"

import "./ClientEdit.css?vue&type=style&index=0&id=c62350ac&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c62350ac"]])

export default __exports__